// PARAQTA — оқу мақсаттары (айлық, күндік, жылдық).
// localStorage кілті: 'paraqta_goals' — өзгеріссіз қалады.

import { toast } from '../../utils/toast.js';

const LABELS = {
  books_month: 'Айына кітап',
  pages_day: 'Күніне бет',
  books_year: 'Жылына кітап',
};

export function initGoals() {
  renderGoals(JSON.parse(localStorage.getItem('paraqta_goals') || '[]'));
}

export function renderGoals(goals) {
  const el = document.getElementById('goalsList');
  if (!el) return;
  if (!goals.length) {
    el.innerHTML = '<p style="font-size:.75rem;color:var(--ink4)">Мақсат қойылмаған</p>';
    return;
  }
  el.innerHTML = goals.map(g => {
    const pct = Math.min(100, Math.round((g.current || 0) / g.target * 100));
    return '<div class="goal-card"><div class="goal-title">' + LABELS[g.type] + ': ' + (g.current || 0) + ' / ' + g.target +
      '</div><div class="goal-prog"><div class="goal-bar"><div class="goal-fill" style="width:' + pct + '%"></div></div>' +
      '<span class="goal-lbl">' + pct + '%</span></div></div>';
  }).join('');
}

export function showGoalModal() {
  document.getElementById('goalModal').style.display = 'flex';
}

export function closeGoalModal() {
  document.getElementById('goalModal').style.display = 'none';
}

export function saveGoal() {
  const type = document.getElementById('goalType').value;
  const target = parseInt(document.getElementById('goalTarget').value, 10);
  if (!target || target < 1) {
    toast('Сан енгізіңіз');
    return;
  }
  const goals = JSON.parse(localStorage.getItem('paraqta_goals') || '[]');
  goals.push({ type, target, current: 0, created: new Date().toISOString() });
  localStorage.setItem('paraqta_goals', JSON.stringify(goals));
  renderGoals(goals);
  closeGoalModal();
  toast('Мақсат қойылды!');
}

export function updateGoalProgress(d) {
  const goals = JSON.parse(localStorage.getItem('paraqta_goals') || '[]');
  const s = d.stats || {};
  goals.forEach(g => {
    if (g.type === 'books_month' || g.type === 'books_year') {
      g.current = s.finished || 0;
    }
    if (g.type === 'pages_day') {
      const tp = (d.recent_progress || []).filter(p => {
        const dd = new Date(p.timestamp);
        return dd.toDateString() === new Date().toDateString();
      });
      g.current = tp.reduce((sum, p) => sum + (p.page || 0), 0);
    }
  });
  localStorage.setItem('paraqta_goals', JSON.stringify(goals));
  renderGoals(goals);
}
